<template>
  <div>
    <h1 class="h2 mt-4">Díjfizetés És Kedvezmények</h1>
    <div class="form-group row mb-3">
      <div class="col-sm-4">
        <b
          >Milyen díjfizetési módot szeretne választani? <span class="text-danger">*</span>
          <span
            class="info"
            id="dijfizetes_modja-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            >?</span
          ></b
        >
      </div>
      <div class="col-sm-8 row">
        <input type="text" hidden v-model="paymentType" name="dijfizetes_mod" />
        <div class="col-md-3 form-group mb-2">
          <div
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click="paymentType = 'online'"
            :class="{
              'btn-red': paymentType == 'online',
              'btn-outline-danger': paymentType !== 'online',
            }"
          >
            Online bankkártyás fizetés
          </div>
        </div>
        <div class="col-md-3 form-group mb-2">
          <div
            class="btn w-100 h-100 d-flex align-items-center justify-content-center"
            @click="paymentType = 'atutalas'"
            :class="{
              'btn-red': paymentType == 'atutalas',
              'btn-outline-danger': paymentType !== 'atutalas',
            }"
          >
            Átutalás
          </div>
        </div>
      </div>
      <small id="dijfizetes_modja-error" class="text-danger input-alert"></small>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Milyen díjfizetési gyakorisággal szeretné fizetni a szerződés díját?
        <span class="text-danger">*</span>
        <span
          class="info"
          id="dijfizetes_gyakorisaga-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          >?</span
        ></label
      >
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="dijfizetes_gyakorisag"
            id="freq_year"
            :value="'eves'"
            v-model="paymentFrequency"
          />
          <label class="form-check-label" for="freq_year">
            Éves
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="dijfizetes_gyakorisag"
            id="freq_quarterly"
            :value="'negyedeves'"
            v-model="paymentFrequency"
          />
          <label class="form-check-label" for="freq_quarterly">
            Negyedéves
          </label>
        </div>
        <small id="dijfizetes_gyakorisaga-error" class="text-danger input-alert"></small>
      </div>
    </div>
    <div class="form-group row mb-3">
      <label class="col-sm-4"
        >Szeretné, ha a Biztosító (postai levelezés helyett) elektronikus formában kommunikálna
        Önnel? <span class="text-danger">*</span>
        <span
          class="info"
          id="elektronikus_kommunikacio-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          >?</span
        >
      </label>
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekommunikacio"
            id="e_kommunikacio_igen"
            :value="1"
            v-model="electronicContact"
          />
          <label class="form-check-label" for="e_kommunikacio_igen">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekommunikacio"
            id="e_kommunikacio_nem"
            :value="0"
            v-model="electronicContact"
          />
          <label class="form-check-label" for="e_kommunikacio_nem">
            Nem
          </label>
        </div>
        <small class="text-danger"
          >Elektronikus kommunikáció választásakor további -5% kedvezményt adunk az éves
          díjból.</small
        ><br />
        <span v-if="!electronicContact"
          ><small class="text-warning fw-bold input-alert">
            Ebben az esetben az összes dokumentumot kinyomtatjuk és postán is küldjük Önnek. Ez egy
            sokkal lassabb és környezetszennyezőbb folyamat, valamint így nem takarít meg 5%-ot a
            végső árból. </small
          ><br
        /></span>

        <small id="elektronikus_kommunikacio-error" class="text-danger input-alert"></small>
      </div>
    </div>
    <!-- <div class="form-group row mb-3">
      <label class="col-sm-4">
        Szeretné a kárrendezést (személyes ügyintézés vagy postai levelezés helyett)
        elektronikusan/digitálisan végezni?
        <span class="text-danger">*</span>
        <span
          class="info"
          id="elektronikus_karrendezes-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          >?</span
        >
      </label>
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekarrendezes"
            id="e_karrendezes_igen"
            :value="1"
            v-model="electronicInsuring"
          />
          <label class="form-check-label" for="e_karrendezes_igen">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="ekarrendezes"
            id="e_karrendezes_nem"
            :value="0"
            v-model="electronicInsuring"
          />
          <label class="form-check-label" for="e_karrendezes_nem">
            Nem
          </label>
        </div>
        <small class="text-danger"
          >Elektronikus kárrendezés választásakor további -5% kedvezményt adunk az éves
          díjból.</small
        ><br />
        <small id="ekarrendezes-error" class="text-danger input-alert"></small>
      </div>
    </div> -->
    <!-- <div class="form-group row">
      <label class="col-sm-4" for="kedvezmenykod">Kedvezménykód:</label>
      <div class="col-sm-8">
        <input
          class="form-control mb-2"
          type="text"
          id="kedvezmenykod"
          name="kedvezmenykod"
          v-model="couponCode"
        />
      </div>
    </div> -->
    <div class="form-group row mb-3">
      <label class="col-sm-4">
        Igénybe szeretné venni az életkor alapú kedvezményünket?
        <span class="text-danger">*</span>
        <span
          class="info"
          id="eletkorkedvezmeny-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          >?</span
        >
      </label>
      <div class="col-sm-8">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="eletkorkedvezmeny"
            id="eletkorkedvezmeny_igen"
            :value="1"
            v-model="ageDiscount"
          />
          <label class="form-check-label" for="eletkorkedvezmeny_igen">
            Igen
          </label>
        </div>
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="eletkorkedvezmeny"
            id="eletkorkedvezmeny_nem"
            :value="0"
            v-model="ageDiscount"
          />
          <label class="form-check-label" for="eletkorkedvezmeny_nem">
            Nem
          </label>
        </div>
        <small class="text-danger"
          >A kedvezmény a következő oldalon megadott életkorból kerül kiszámításra</small
        ><br />
        <small id="eletkor_kedvezmeny-error" class="text-danger input-alert"></small>
      </div>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';

export default {
  data() {
    return {
      yearlyDefaultPrice: 0,
      accessorySumPrice: 0,
      discountPrice: 0,
      frequencyPrice: 0,
    };
  },
  computed: {
    ...mapFields([
      'generalInfo.contractFor',
      'insuranceProperty.chosenInsurancePrice',
      'insurancePersonalGoods.calculatedInsurancePrice',
      'insurancePersonalGoods.acceptCalculatedInsurance',
      'insurancePersonalGoods.priceType',
      'insurancePersonalGoods.allGoodsPrice',
      'chooseableAccesories.valuablesAbove200',
      'chooseableAccesories.valuablesAboveInputs',
      'chooseableAccesories.accidentInsuranceType',
      'electronicContact',
      'electronicInsuring',
      'ageDiscount',
      'couponCode',
    ]),
    ...mapFields({
      sideBuildings: 'insuranceSideBuildings.list',
      accesoriesList: 'chooseableAccesories.selectableList',
      insuredPersonTemplate: 'chooseableAccesories.travelInsuranced.template',
      insuredPersons: 'chooseableAccesories.travelInsuranced.list',
      paymentType: 'paymentOptions.type',
      paymentFrequency: 'paymentOptions.frequency',
      eves_dij_csokkentett: 'kieg_kedv_dij',
      gyakorisagdij: 'gyakorisag_dij_havi',
    }),
    canChooseMonthlyPayment() {
      return !(this.gyakorisagdij < 2000);
    },
  },
  watch: {
    paymentFrequency: function(value) {
      if (value == 'havi' && !this.canChooseMonthlyPayment) this.paymentFrequency = 'negyedeves';
    },
    contractReason: function(value) {
      if (value == 'uj_szerzodes') this.oldContructNumber = '';
    },
  },
  mounted() {
    if (this.paymentFrequency == 'havi' && !this.canChooseMonthlyPayment)
      this.paymentFrequency = 'negyedeves';
  },
};
</script>
